import { FunctionComponent, MouseEventHandler, ReactNode, useMemo } from "react";
import styles from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "plain";

export interface IButtonProps {
  children?: ReactNode;
  variant: ButtonVariant;
  type?: "submit" | "button";
  disabled?: boolean;
  className?: string;
  leftIcon?: FunctionComponent<{ className?: string }>;
  rightIcon?: FunctionComponent<{ className?: string }>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  loading?: boolean
  size?: "small" | "large";
}

const Button = ({
  children,
  variant,
  type,
  disabled,
  onClick,
  className,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  loading,
  size
}: IButtonProps) => {

  const _className = useMemo(() => (
    [
      styles.root,
      styles[`root--${variant}`],
      styles[`root--${size}`],
      loading ? styles.loading : undefined,
      className,
    ].filter(x => x !== undefined).join(" ")
  ), [variant, className, loading, disabled]);

  return (
    <button
      className={_className}
      type={type ?? "button"}
      onClick={onClick}
      disabled={disabled}
    >
      {LeftIcon && <LeftIcon />}
      {children && children}
      {RightIcon && <RightIcon />}
    </button>
  );
};

export default Button;
